
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, Box } from "@mui/material";
import AuthLayout from './layouts.js/AuthLayout';
import AuthRegisterLayout from './layouts.js/RegisterLayout';
import DashboardLayout from './layouts.js/DashboardLayout';
import Test from './pages/AuthPages/test';
import Login from './pages/AuthPages/Login/Login';
import ForgetPassword from './pages/AuthPages/Login/ForgetPassword';
import VerificationScreen from './pages/AuthPages/Login/VerificationScreen';
import ResetPassword from './pages/AuthPages/Login/Resetpassword';
import Registeration from './pages/AuthPages/Registeration/Registeration';
import Location from './pages/AuthPages/Registeration/Locations';
import CreateProfile from './pages/AuthPages/Registeration/CreateProfile';
import Region from './pages/AuthPages/Registeration/Region';
import FaceScanning from './pages/AuthPages/Registeration/FaceScanning';
import RegisterationVerification from './pages/AuthPages/Registeration/RegisterationVerification';
import Dashboard from './pages/AdminPages/Dashboard/Dashboard';
import ChangePassword from './pages/AdminPages/Dashboard/ChangePassword';
import ManageInvitesTable from "./pages/AdminPages/ClientAcquisition/InvitedClients/InvitedClients";
import ClientsRequests from './pages/AdminPages/ClientAcquisition/ClientsRequests/ClientRequests';
import ClientsTrial from './pages/AdminPages/ClientAcquisition/ClientsTrial/ClientsTrial';
import ActiveCompanies from './pages/AdminPages/MyClients/ActiveCompanies/ActiveCompanies';
import InactiveCompanies from './pages/AdminPages/MyClients/InactiveCompanies/InactiveCompanies';
import MyWallet from './pages/AdminPages/Wallet/MyWallet/MyWallet';
import CommissionRecord from './pages/AdminPages/Wallet/ComissionRecords/CommissionRecord';
import Messages from './pages/AdminPages/Messages/Inbox/Inbox';
import SuperAdmin from './pages/AdminPages/Messages/SuperAdmin/SuperAdmin';
import CompanyAdmin from './pages/AdminPages/Messages/CompanyAdmin/CompanyAdmin';
import ReportsandStatistics from "./pages/AdminPages/Report & Statistics/Reports&Statistics";
import Notifications from './pages/AdminPages/Notifications.js/Notifications';
import Settings from './pages/AdminPages/Settings/Settings';
import PrivateRoute from './Routes/PrivateRoutes';
import PublicRoute from './Routes/PublicRoute';
import OTPScreen from "./pages/AuthPages/Registeration/OTPScreen";
import {toast,Toaster} from "react-hot-toast";
import AnyError from "./components/anyError";
// import {interceptFetchErrors} from "./pages/Hooks/Intercept"
import useHealthCheck from './pages/Hooks/HealthCheck';
import GlobalHealthWrapper from './components/GlobalHealthCheck';
import ErrorBoundary from './components/ErrorBoundry';
import ScrollToTop from './components/ScrollToTop';
import AddressLocation from './pages/AuthPages/Registeration/AddressLocation';
import InviteDetails from './pages/AdminPages/ClientAcquisition/InvitedClients/ClientsDetails';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import VerifyInvite from "./pages/AuthPages/Login/VerifyInvite";
import InviteResetPassword from "./pages/AuthPages/Login/InviteResetPassword";
import ModalVerify from "./pages/AuthPages/Login/Modalverify";
import AdminApproval from "./pages/AuthPages/Login/AdminApproval"
import i18n from './i18n';
import { useEffect } from 'react';
import AccountSetting from "./pages/AdminPages/Settings/AccountSetting";
import GeneralSetting from './pages/AdminPages/Settings/GerneralSetting';
import useGlobalUnreadCount from './hooks/useGlobalUnreadCount';
  import { useJsApiLoader } from "@react-google-maps/api";
import { MAPS_API_KEY } from "./components/mapKey";
const theme = createTheme({
  palette: {
    primary: {
      main: "#006EC2", 
      text:"#8B8D97",
    },
    tertiary: {
      main: "#2C384C", // Tertiary color
    },
    text: {
      primary: "#8B8D97",
    },
  },
  typography: {
 
    h1: {
      fontFamily: "Volkhov, serif",
      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h2: {

      fontSize: "58px",
      fontWeight: 600,
      lineHeight: 1.1,
    },
    h3: {
   
      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h4: {
 
      fontSize: "68px",
      fontWeight: 700,
      lineHeight: 1.1,
    },
    body1: {

      fontSize: "28px",
      fontWeight: 500,
      lineHeight: 1.7,
    },
  },
});
const GOOGLE_MAP_LIBRARIES = ["places"];
function App() {
  // Initialize global unread count fetching and socket listeners
  useGlobalUnreadCount();

    // Get browser language function
    const getBrowserLanguage = () => {
      const browserLang = navigator.language || navigator.userLanguage;
      console.log('Browser language detected:', browserLang);
      
      // Extract language code (e.g., 'es-ES' -> 'es', 'en-US' -> 'en')
      const langCode = browserLang.split('-')[0].toLowerCase();
      console.log('🌐 Language code:', langCode);
      
      // Map to supported languages
      const supportedLanguages = {
        'es': 'es', // Spanish
        'en': 'en', // English
      };
      
      // Return supported language or default to English
      const detectedLang = supportedLanguages[langCode] || 'en';
      console.log('🌐 Mapped to language:', detectedLang);
      
      return detectedLang;
    };
     useEffect(() => {
     const savedLang = localStorage.getItem("i18nextLng");
     
     
     if (!savedLang) {
     // 👶 First-time user → use browser language
     const detectedLanguage = getBrowserLanguage();
     console.log("🌍 No saved language, using browser:", detectedLanguage);
     i18n.changeLanguage(detectedLanguage);
     } else {
     // 🔒 Returning user → respect their choice
     console.log("🔒 Using saved language:", savedLang);
     }
     }, []);
  
    // useEffect(() => {
    //   // Restore auth from localStorage on app load
    
    //   // Auto-detect and set language based on browser language
    //   const savedLang = localStorage.getItem('lang');
    //   // if (!savedLang) {
    //     const detectedLanguage = getBrowserLanguage();
    //     console.log('🌐 Setting language to:', detectedLanguage);
    //     i18n.changeLanguage(detectedLanguage);
    //     localStorage.setItem('lang', detectedLanguage);
    //   // }
    // }, []);


//     const { isLoaded } = useJsApiLoader({
//   googleMapsApiKey: MAPS_API_KEY,
//   libraries: ["places"],
// });


const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: MAPS_API_KEY,
  libraries: ["places"],
});

if (!isLoaded) return null;
  return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
  <Router>
      <ThemeProvider theme={theme}>
        <Toaster/>
         {/* <GlobalHealthWrapper />  */}
              <ScrollToTop />  
      <Routes>
      <Route element={<PublicRoute><AuthLayout /></PublicRoute>}>
           <Route path="/" element={<Login/>}/>
           <Route path="/forget-password" element={<ForgetPassword/>}/>

           <Route path='/verification' element={<VerificationScreen/>}/>
            <Route path='/reset-password' element={<ResetPassword/>}/>
                <Route path="/verify" element={<ModalVerify/>} />

           
        </Route>

         <Route element={<AuthLayout />}>
    <Route path="/something-went-wrong" element={<AnyError />} />
  </Route>

  
           <Route element={<PublicRoute><AuthRegisterLayout /></PublicRoute>}>
                        <Route path="/account-executive/account-executive/verify-invite" element={<VerifyInvite/>} />
                         <Route path="/admin-approval" element={<AdminApproval/>}/>

               <Route path="/register" element={<Registeration/>}/>
               <Route path="/set-password" element={<InviteResetPassword/>} />
  <Route path="/account-executive/account-executive/set-password" element={<InviteResetPassword/>} />
                <Route path="/otp-screen" element={<OTPScreen/>}/>
                <Route path="/location" element={<Location/>}/>
                <Route path="/create-profile" element={<CreateProfile/>}/>
                 <Route path="/address-location" element={<AddressLocation/>}/>
                {/* <Route path="/region" element={<Region/>}/> */}
                <Route path="/face-scanning" element={<FaceScanning/>}/>
                <Route path="/registration-verification" element={<RegisterationVerification/>}/>                  
        </Route>
     <Route element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
           <Route path="/dashboard" element={<Dashboard/>}/>
             {/* <Route path="/change-password" element={<ChangePassword/>}/> */}
               <Route path="/invited-clients" element={<ManageInvitesTable/>}/>
                <Route path="/clients-requests" element={<ClientsRequests/>}/>
                 <Route path="/clients-trial" element={<ClientsTrial/>}/>
                  <Route path="/active-companies" element={<ActiveCompanies/>}/>
                  <Route path="/inactive-companies" element={<InactiveCompanies/>}/>
                  <Route path="/my-wallet" element={<MyWallet/>}/>
                    <Route path="/commission-record" element={<CommissionRecord/>}/>
                   <Route path="/messages" element={<Messages/>}/>
                   <Route path="/messages/super-admin" element={<SuperAdmin/>}/>
                   <Route path="/messages/company-admin" element={<CompanyAdmin/>}/>
                

                     
                  
                        <Route path="/reports-services" element={< ReportsandStatistics/>}/>
                          <Route path="/notifications" element={< Notifications/>}/>
                           <Route path="/settings" element={< Settings/>}/>
                           <Route path="/settings/account" element={<AccountSetting />} />
<Route path="/settings/general" element={<GeneralSetting />} />
        </Route>

      </Routes>

      </ThemeProvider>
      </Router>
      </LocalizationProvider>
  );
}

export default App;
